require('./groupon.coffee');

Groupon.Validate = {
  email: function(value) {
    var re;
    value = $.trim(value);
    if (value.length > 100) {
      return false;
    }
    re = /^(^[a-zA-Z0-9\!\#\$\%\&'\*\+\-\/\=\?\^\_\`\{\|\}\~]+[.]?[a-zA-Z0-9\!\#\$\%\&'\*\+\-\/\=\?\^\_\`\{\|\}\~]+|[a-zA-Z0-9\!\#\$\%\&'\*\+\-\/\=\?\^\_\`\{\|\}\~]{1})@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;
    return re.test(value);
  },
  zip: function(value) {
    var regexp, zip;
    if (value === '' || value === 'undefined') {
      return false;
    }
    zip = $.trim(value);
    regexp = /(^([0-9]{5}(-[0-9]{4})?)$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)/;
    return regexp.test(zip);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDkzODE4ODg5MDUtMTk5MDIvcHJvZHVjdGlvbi0yMDE3LjEwLjMwXzE0LjIyL3N1YnNjcmlwdGlvbl9mbG93L21vZHVsZXMvZ3JvdXBvbi9mcm9udGVuZC92YWxpZGF0ZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9zcmFqZW5kcmFuL25hcGlzdHJhbm8vYnVpbGQvMTUwOTM4MTg4ODkwNS0xOTkwMi9wcm9kdWN0aW9uLTIwMTcuMTAuMzBfMTQuMjIvc3Vic2NyaXB0aW9uX2Zsb3cvbW9kdWxlcy9ncm91cG9uL2Zyb250ZW5kL3ZhbGlkYXRlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFXQSxPQUFBLENBQVEsa0JBQVI7O0FBRUEsT0FBTyxDQUFDLFFBQVIsR0FHRTtFQUFBLEtBQUEsRUFBTyxTQUFDLEtBQUQ7QUFDTCxRQUFBO0lBQUEsS0FBQSxHQUFRLENBQUMsQ0FBQyxJQUFGLENBQU8sS0FBUDtJQUNSLElBQWdCLEtBQUssQ0FBQyxNQUFOLEdBQWUsR0FBL0I7QUFBQSxhQUFPLE1BQVA7O0lBQ0EsRUFBQSxHQUFLO0FBQ0wsV0FBTyxFQUFFLENBQUMsSUFBSCxDQUFRLEtBQVI7RUFKRixDQUFQO0VBTUEsR0FBQSxFQUFLLFNBQUMsS0FBRDtBQUNILFFBQUE7SUFBQSxJQUFnQixLQUFBLEtBQVMsRUFBVCxJQUFlLEtBQUEsS0FBUyxXQUF4QztBQUFBLGFBQU8sTUFBUDs7SUFDQSxHQUFBLEdBQU0sQ0FBQyxDQUFDLElBQUYsQ0FBTyxLQUFQO0lBQ04sTUFBQSxHQUFVO1dBQ1YsTUFBTSxDQUFDLElBQVAsQ0FBWSxHQUFaO0VBSkcsQ0FOTCJ9
